// extracted by mini-css-extract-plugin
module.exports = {"banner":"HeroBanner_banner__3iwmP","text":"HeroBanner_text__brzET","container":"HeroBanner_container__3nW31","button":"HeroBanner_button__jZXxu"};